import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  TextField,
  CssBaseline,
  Container,
  Grid,
} from "@material-ui/core";
import ValidationsContext from "../../../context/validations/validationsContext";
import { makeStyles } from "@material-ui/core/styles";
import AuthContext from "../../../context/autentication/authContext";
import InputMask from "react-input-mask";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
const useStyles = makeStyles((theme) => ({
  step: {
    width: "10%",
    display: "flex",
    flexDirection: "row",
    padding: "0px 1em 0px 0px",
    marginLeft: "65%",
    fontSize: "30px",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    display: "flex",
    /*         height: "100%",*/
    flexDirection: "row-reverse",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formInputs: {
    width: "73.333333%",
    height: "100%",
  },
  formTelefonos: {
    width: "33.33333333%",
    height: "100%",
    marginLeft: "1.2em",
    padding: "0em 1em 1em 1em",
  },
  telList: {
    height: "50%",
    maxHeight: "30vh",
    width: "100%",
    marginRight: "0px",
    marginLeft: "1em",
    paddingBottom: "1em",
    paddingRight: "0px",
    paddingTop: "0px",
  },
  telListPaper: {
    width: "100%",
    height: "100%",
    maxHeight: "100%",
    marginRight: "0px",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },
}));

export default function Formulario({
  grabarCliente,
  errorCliente,
  handleNext,
  handleBack,
  cliente,
}) {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const { autenticado, rol, usuario, cerrarSesion } = authContext;

  const validationsContext = useContext(ValidationsContext);
  const {
    validateForm,
    validateDispositivoNombre,
    validateUsername,
    validateeMail,
    validateDirecciones,
    validateCuit,
    validatePassword,
    validateCodigoArea,
    validateNumeroTelefono,
    validateRepeatPassword,
  } = validationsContext;
  const [state, setState] = useState({
    cuit: cliente.cuit ? cliente.cuit : "",
    razonSocial: cliente.razonSocial ? cliente.razonSocial : " ",
  });
  const [cuit, setCuit] = useState("");
  ////pasos step
  function getSteps() {
    return [" ", " ", " ", " "];
  }
  const steps = getSteps();
  ///fin step
  const isFormIncomplete = () => {
    return state.cuit.trim() === "" || state.razonSocial.trim() === "";
  };
  useEffect(() => {
    setErrors({
      cuit: "",
      razonSocial: "",
      nombre: "",
      paisSelect: "",
      provinciaSelect: "",
      localidad: "",
      email: "",
      password: "",
      password2: "",
    });
    // eslint-disable-next-line
  }, []);
  const [errors, setErrors] = useState({
    cuit: "",
    razonSocial: "",
    nombre: "",
    paisSelect: "",
    provinciaSelect: "",
    localidad: "",
    direccion: "",
    email: "",
    password: "",
    password2: "",
  });
  const validarCuit = (cuit) => {
    let validado = cuit.split(" - ");
    let completo = validado[0] + validado[1] + validado[2];
    return completo;
  };
  const onChange = (e) => {
    // cargo el preview
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
    switch (e.target.name) {
      case "razonSocial":
        setErrors({
          ...errors,
          razonSocial: validateDispositivoNombre(e.target.value),
        });
        break;
      case "cuit":
        setErrors({
          ...errors,
          cuit: validateCuit(validarCuit(e.target.value)),
        });
        break;
      default:
        break;
    }
  };
  const cuitFormato = (state) => {
    const n1 = state.cuit.slice(0, 2);
    const n2 = state.cuit.slice(5, 13);
    const n3 = state.cuit.slice(16, 17);
    const n4 = n1 + n2 + n3;
    setState({ ...state, cuit: n4 });
    handleNext(state);
  };

  // Cuando el usuario guardar o actualizar la localidad
  const onSubmit = (e) => {
    e.preventDefault();
    // Validar que no haya campos vacios
    if (!validateForm(errors) || isFormIncomplete()) {
      errorCliente("Todos los campos con * son obligatorios", "error");
    } else {
      setErrors({
        cuit: "",
        razonSocial: "",
        nombre: "",
        paisSelect: "",
        provinciaSelect: "",
        localidad: "",
        direccion: "",
        email: "",
        password: "",
        password2: "",
      });
    }
  };
  return (
    <div style={{ width: "550px" }}>
      <Stepper
        nonLinear
        activeStep={0}
        className={classes.step}
        style={{ backgroundColor: "#fafafa" }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepButton style={{ cursor: "default" }}>{label}</StepButton>
          </Step>
        ))}
      </Stepper>
      <CssBaseline />

      <div
        className={classes.form}
        noValidate
        onSubmit={onSubmit}
        autoComplete="off"
      >
        <Grid container justify="space-around">
          <Grid item xs={11}>
            <InputMask
              mask="99 \- 99999999 \- 9"
              value={state.cuit}
              onChange={onChange}
            >
              {() => (
                <TextField
                  type="text"
                  variant="outlined"
                  error={errors.cuit.length > 0}
                  margin="normal"
                  required
                  fullWidth
                  id="cuit"
                  label={errors.cuit.length > 0 ? errors.cuit : "Cuit"}
                  name="cuit"
                  autoComplete="cuit"
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={11}>
            <TextField
              variant="outlined"
              error={errors.razonSocial.length > 0}
              margin="normal"
              required
              fullWidth
              id="razonSocial"
              label={
                errors.razonSocial.length > 0
                  ? errors.razonSocial
                  : "Razón Social"
              }
              name="razonSocial"
              value={state.razonSocial}
              onChange={onChange}
            />
          </Grid>
          <Grid item xs={12}>
            <Grid container justify="flex-end">
              <Grid item xs={6} md={6} lg={6}>
                {isFormIncomplete() || !validateForm(errors) ? (
                  <Button
                    mx="auto"
                    disabled
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Siguiente
                  </Button>
                ) : (
                  <Button
                    mx="auto"
                    type="submit"
                    fullWidth
                    variant="contained"
                    style={{ color: "#FCFCFC", backgroundColor: "#0B3845" }}
                    className={classes.submit}
                    onClick={() => cuitFormato(state)}
                  >
                    Siguiente
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
